import { atom } from "jotai";
import { StatusHistoryBoxProps } from "./components/StatusHistoryBx";
import { MessageStatus } from "./utils/contants";

export const ticketAtom = atom<any>(null);
export const ticketIdAtom = atom<number | string>("");
export const workOrderIDAtom = atom<number | string >("")
export const appError = atom<string | null>(null);
export const statusHistoryAtom = atom<Array<StatusHistoryBoxProps> | null>(null)
export const messageCountAtom = atom<number>(10)
export const currentPageAtom = atom<number>(1)

export const showTicketDetailsAtom = atom(true);

export const loadingAtom = atom(false);

export const merchantAtom = atom<any>(null);

export const conversationsAtom = atom<any[]>([]);

export const messageStatusAtom = atom<{
  messageId: string;
  loading: boolean;
  status: MessageStatus | null;
}>({
  messageId: "",
  loading: false,
  status: null,
});
